module.exports = __webpack_public_path__ + "img/banner-1-min.78a7df6d.png";